export const CONFIRM_PICKUP_PATH = 'confirm-pickup';
export const ENTER_CODE_PATH = 'enter-code';
export const HELP_CENTER_PATH = 'help-center';
export const ORDER_PICKUP_PATH = 'order-pickup';
export const OVERFLOW_AREA_PATH = 'overflow-area';
export const PICKUP_TIMEOUT = 'pickup-timeout';
export const REMOTE_PICKUP_PATH = 'remote-pickup';
export const WAITING_QUEUE_PATH = 'waiting-queue';
export const ROUTES = {
  CONFIRM_PICKUP: `/${REMOTE_PICKUP_PATH}/${CONFIRM_PICKUP_PATH}`,
  ENTER_CODE: `/${REMOTE_PICKUP_PATH}/${ENTER_CODE_PATH}`,
  HELP_CENTER: `/${REMOTE_PICKUP_PATH}/${HELP_CENTER_PATH}`,
  ORDER_PICKUP: `/${REMOTE_PICKUP_PATH}/${ORDER_PICKUP_PATH}`,
  OVERFLOW_AREA: `/${REMOTE_PICKUP_PATH}/${OVERFLOW_AREA_PATH}`,
  PICKUP_TIMEOUT: `/${REMOTE_PICKUP_PATH}/${PICKUP_TIMEOUT}`,
  REMOTE_PICKUP: `/${REMOTE_PICKUP_PATH}`,
  WAITING_QUEUE: `/${REMOTE_PICKUP_PATH}/${WAITING_QUEUE_PATH}`,
} as const;
